const statusColours = {
  new: "text-red-500",
  new_web: "text-orange-500",
  typing: "text-slate-400",
  typochecking: "text-slate-500",
  techchecking: "text-slate-600",
  typing_web: "text-orange-400",
  cert: "text-emerald-500",
  head: "text-emerald-500",
  email: "text-emerald-500",
  digicert: "text-green-500",
  digipremcert: "text-green-500",
  premPhoto: "text-green-700",
  supportingLetter: "text-emerald-500",
  fulfiling: "text-emerald-500",
  webResearch_web: "text-orange-700",
  techspec: "text-amber-700",
  docwallet: "text-amber-700",
};

const buttonClasses = {
  default:
    "btn bg-gradient-to-br from-emerald-800 to-emerald-700 hover:from-emerald-700 hover:to-emerald-600 text-white",
  green:
    "btn bg-gradient-to-br from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 text-white",
  blue: "btn bg-gradient-to-br from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white",
  red: "btn bg-gradient-to-br from-red-600 to-red-500 hover:from-red-500 hover:to-red-400 text-white",
};

const extraAuths = ["certsystem", "reporting", "admin"];
const atBMM = "@britishmotormuseum.co.uk";

const layouts = [
  { key: "certstd", label: "Standard Certificate" },
  { key: "certprem", label: "Premier Certificate" },
  { key: "digiCertStd", label: "Digital Standard Certificate" },
  { key: "digiCertPrem", label: "Digital Premier Certificate" },
  { key: "email", label: "Email copy" },
  { key: "paper", label: "Paper copy" },
];

export { statusColours, buttonClasses, extraAuths, atBMM, layouts };
